/**
 * The applicant's key documents & reports — the verification boxes
 * (VerificationField: popover with upload / assign / Remove & Hide /
 * Download / Preview, the date with Save, validity against the loan's
 * reference day and its closing). Lives in the applicant sidebar's
 * "Key Docs & Reports" tab; it replaced the older required-documents
 * checklist there, and the boxes moved here off the Applicants-tab card.
 *
 * Items, from verificationConfig.js: Credit Auth / Loan Application (either
 * document satisfies it), Credit Report, Background Check, Photo
 * Identification. The standalone Loan Application item is left out — the
 * credit auth box already takes a loan application.
 */
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import VerificationField from "../tabs/LoanDrilldownApplicantsTab/components/VerificationField";
import {
  VERIFICATIONS_BY_KEY,
  useVerificationDocs,
} from "./verificationConfig";

export const KEY_DOC_ITEMS = [
  "creditAuth",
  "creditReport",
  "background",
  "photoId",
];

const ApplicantKeyDatesSection = ({ borrower, keys = KEY_DOC_ITEMS }) => {
  const loan = useSelector((s) => s.loanDrilldown);
  const docs = useVerificationDocs(loan, borrower?._id);
  if (!borrower?._id) return null;
  return (
    <Box
      sx={{
        display: "grid",
        // Two across in the sidebar; one when it is dragged narrow.
        gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
        gap: 2,
      }}
    >
      {keys
        .map((k) => VERIFICATIONS_BY_KEY[k])
        .filter(Boolean)
        .map((v) => (
          <VerificationField
            key={v.key}
            label={v.label}
            borrower={borrower}
            loanId={loan?._id}
            dateField={v.dateField}
            dateMode={v.dateMode}
            dateLabel={v.dateLabel}
            dateHelp={v.dateHelp}
            target={v.target}
            altTargets={v.altTargets}
            files={docs[v.key]?.files}
            candidates={docs[v.key]?.candidates}
          />
        ))}
    </Box>
  );
};

ApplicantKeyDatesSection.propTypes = {
  borrower: PropTypes.object,
  /** Which verification items to show (verificationConfig keys). */
  keys: PropTypes.arrayOf(PropTypes.string),
};

export default ApplicantKeyDatesSection;
